import React from 'react'

import { Icon, Loader } from '@fourthwall/components'
import { RefreshIcon } from '@fourthwall/icons'

import * as S from './SkipButton.styled'

type SkipButtonProps = {
  isLoading?: boolean
  onClick: () => void
}

export const SkipButton = ({ isLoading, onClick }: SkipButtonProps) => {
  const renderIcon = () => {
    if (isLoading) {
      return (
        <S.Loader>
          <Loader size="small" appearance="primary" />
        </S.Loader>
      )
    }

    return <Icon component={RefreshIcon} height={18} />
  }

  return (
    <S.Container onClick={onClick}>
      {renderIcon()}
      Skip
    </S.Container>
  )
}
